import { render, staticRenderFns } from "./topic_bind_model_edit.vue?vue&type=template&id=b6bc544e"
import script from "./topic_bind_model_edit.vue?vue&type=script&lang=js"
export * from "./topic_bind_model_edit.vue?vue&type=script&lang=js"
import style0 from "./topic_bind_model_edit.vue?vue&type=style&index=0&id=b6bc544e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports